import { useSDK, useSDKReady } from "@godgpt/react";

export function Home() {
  const sdk = useSDK();
  const isReady = useSDKReady();

  const modules = [
    { name: "auth", icon: "🔐", description: "Authentication with OAuth providers", path: "/auth" },
    { name: "api", icon: "🌐", description: "API client with interceptors", path: "/api" },
    { name: "i18n", icon: "🌍", description: "Internationalization support", path: "/i18n" },
  ];

  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title">SDK Playground</h1>
        <p className="page-subtitle">
          Interactive testing environment for @godgpt SDK packages
        </p>
      </div>

      <div className="card mb-lg">
        <div className="card-header">
          <div className="card-title">
            <span className="card-icon">⚡</span>
            SDK Status
          </div>
          <span className={`card-badge ${isReady ? "success" : "warning"}`}>
            {isReady ? "Ready" : "Initializing..."}
          </span>
        </div>
        <div className="code-block">
{`const sdk = createSDK({ debug: true });

// Registered Modules:
${modules.map(m => `sdk.has("${m.name}") → ${sdk.has(m.name)}`).join("\n")}`}
        </div>
      </div>

      <div className="grid grid-3">
        {modules.map((module) => (
          <a
            key={module.name}
            href={module.path}
            className="card"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <div className="flex gap-md" style={{ alignItems: "center" }}>
              <div
                style={{
                  fontSize: "2rem",
                  width: 56,
                  height: 56,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "var(--bg-tertiary)",
                  borderRadius: "var(--radius-md)",
                }}
              >
                {module.icon}
              </div>
              <div>
                <h3 style={{ marginBottom: 4 }}>@godgpt/{module.name}</h3>
                <p style={{ color: "var(--text-secondary)", fontSize: "0.9rem" }}>
                  {module.description}
                </p>
                <span
                  className={`card-badge ${sdk.has(module.name) ? "success" : "error"}`}
                  style={{ marginTop: 8, display: "inline-block" }}
                >
                  {sdk.has(module.name) ? "registered" : "not registered"}
                </span>
              </div>
            </div>
          </a>
        ))}
      </div>

      <div className="card mt-lg">
        <div className="card-header">
          <div className="card-title">
            <span className="card-icon">📦</span>
            Deployment Info
          </div>
          <span className="card-badge info">Cloudflare Pages</span>
        </div>
        <div className="code-block">
{`# Local Development
pnpm install
cd apps/sdk-playground
pnpm dev

# Cloudflare Pages
Build command: pnpm build && pnpm --filter @godgpt/sdk-playground build
Build output:  apps/sdk-playground/dist
Root directory: /`}
        </div>
      </div>
    </div>
  );
}
